import React, {Suspense} from 'react';
import {Routes, Route, useParams} from 'react-router-dom';
import Embed from '@src/Presentation/Embed';

// const Embed2 = React.lazy(() => );
const Player = React.lazy(() => import('@src/Presentation/Player'));
const Iframe = React.lazy(() => import('@src/Presentation/IframeTest'));
const Ebook = React.lazy(() => import('@src/Presentation/Ebook'));
const PrintEbook = React.lazy(() => import('@src/Presentation/PrintEbook'));
const PrintToDoList = React.lazy(() => import('@src/Presentation/PrintToDoList'));

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <Suspense fallback={<div>&nbsp;</div>}>
      <Routes>
        <Route path="/embed/:id" element={<Embed />} />
        <Route path="/player" element={<Player />} />
        <Route path="/iframe-test" element={<Iframe />} />
        <Route path="/ebook/:id" element={<Ebook />} />
        <Route path="/print-ebook/:origin/:id" element={<PrintEbook />} />
        <Route path="/print-todolist/:origin/:id" element={<PrintToDoList />} />
      </Routes>
    </Suspense>
  );
};
